/**-------------------------------  Copyright ---------------------------------
This software has been developed by Orange Labs TGI/OLS/SOFT
Copyright (c) Orange Labs 2018

COPYRIGHT    : This file is the property of Orange Labs.
Copyright Orange Labs 2018, All Rights Reserved

This software is the confidential and proprietary information of Orange Labs.

You shall not disclose such Confidential Information and shall use it only
in accordance with the terms of the license agreement you entered into with
Orange Labs.

AUTHORS      : Orange Labs  TGI/OLS/SOFT
EMAIL        : soft.cybersec@orange.com
-----------------------------------------------------------------------------*/


import { UserVO } from '@/valueObjects/UserVO'

export default {
    state: {
        currentUser: null,
    },
    getters: {
        getCurrentUser: (state: any) => {
            if (isReloadedFromLocalStorage(state.currentUser)) {
                return UserVO.fromPersistentStore(state.currentUser)
            }
            return state.currentUser
        },
    },
    mutations: {
        setCurrentUser(state: any, user: UserVO) {
            state.currentUser = user
        },

        resetCurrentUser(state: any) {
            state.currentUser = new UserVO()
        },
    },
}

function isReloadedFromLocalStorage(user: any): boolean {
    // when the user is reloaded from local storage, it has the wrong type
    return !(user instanceof UserVO)
}
